export const PENDING = 1
export const SUCCESS = 2
export const FAILED = 3
